import { makeStyles } from '@material-ui/core'

import { getFont, lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  ratePlaneRow: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 67,
    alignItems: 'center',
    borderTop: '1px solid #e7e7e7',
    backgroundColor: theme.palette.grey[100]
  },
  ratePlaneRowGrey: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 67,
    alignItems: 'center',
    borderTop: '1px solid #e7e7e7',
    backgroundColor: theme.palette.background.default
  },
  ratePlaneRowForMonth: {
    gridTemplateColumns: '7fr 2fr repeat(31,1fr)',
    [theme.breakpoints.down(1460)]: {
      gridTemplateColumns: '7.5fr 2.5fr repeat(31,1fr)'
    }
  },
  rowName: {
    marginLeft: 3,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15
  },
  rowNameTitle: {
    flex: 1,
    marginLeft: 16,
    // marginLeft: 10,
    fontSize: 12
  },
  rowNameTitleMarginLeft: {
    flex: 1,
    marginLeft: 30,
    fontSize: 12
  },
  dayContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    '& input': {
      fontSize: 12,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
      fontFamily: getFont()
    }
  },
  channelArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`,
    cursor: 'pointer'
  },
  channelArrowRightCollapsed: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  }
}))

export default useStyles
